export default __webpack_public_path__ + "static/thumb-downloads-20674e854c3b24644aed1123b1501d55.jpg";